import React from "react";
import { connect } from "react-redux"
import { withStyles } from '@material-ui/core/styles';
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import Button from "@material-ui/core/Button";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class DeleteModel extends React.Component {
  render(){
    const { showModel, title, onCancel, onOk } = this.props
    return(
      <Dialog open={showModel} onClose={onCancel}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color="primary" autoFocus>
            Cancel
          </Button>
          <Button onClick={onOk} color="primary" variant="contained" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const DeleteModelComponent = withStyles(extendedTablesStyle)(DeleteModel);
export default connect(null)(DeleteModelComponent);



// WEBPACK FOOTER //
// ./src/components/Common/FevoModels/DeleteModel.jsx